export default __webpack_public_path__ + "static/media/Unreal.7c2d6298.png";